// extracted by mini-css-extract-plugin
export default {"profile-page":"ProfilePage_profile-page__3wdJE"};